import { AdminGroups } from '@Containers/Groups';

const AdminGroupsPage: React.FunctionComponent = (): JSX.Element => (
  <AdminGroups />
);

export default AdminGroupsPage;
